import React, { useEffect, useState } from "react";

import {
  IAddUpdateRiderManagementPageProps,
  IAddUpdateRiderManagementPageState,
} from "interfaces/riderManagement.interface";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import TextField from "components/common/TextField/TextField";
import ButtonComponent from "components/common/Button/ButtonComponent";
import { Col, Container, Form, Row } from "reactstrap";
import { Can } from "config/Can";
import "./AddUpdateRiderManagementPage.scss";
import {
  phoneNumberValidate,
  alphaNumericValidator,
  phoneNumberOnlyValidator,
  cnicNumberValidate,
  cnicNumberOnlyValidator,
  numbersOnly,
} from "utils/Validators";
import Toaster from "components/common/Toaster/Toaster";
import LoaderComponent from "components/common/Loader/Loader";
import HeadingText from "components/common/HeadingText/HeadingText";
import backarrow from "../../../assets/images/back_arrow.svg";

import {
  normalizeCreateRiderPayload,
  normalizeRiderManagementUserCreatePayload,
  normalizeRiderManagementUserUpdatePayload,
} from "normalizer/RiderManagementNormalizer";
import { RIDER } from "config/constants";
import { doUserAPIsearch } from "../customer/AddUpdateCustomerPage";
import {
  autoGeneratePassword,
  getWarehousePayloadById,
  convertStringArrayToMultiSelectDropdown,
} from "utils/lib";
import Modal from "components/common/Modal/Modal";
import { updateUserPasswordApiCall } from "redux/sources/CustomerSource";
import { updateRiderDeviceApiCall } from "redux/sources/RiderManagementSource";
import MultiSelectDropDown from "components/common/MultiSelectDropDown/MultiSelectDropDown";
import { IMultiSelectOption, IWarehousePayload } from "interfaces/Index";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";
import {
  normalizeSubTypeForDropdown,
  normalizeSubTypeResponseForDropdown,
  normalizeWarehouseResponseForDropdown,
} from "../../../normalizer/ShipperNormalizer";
import { defaultWarehouse } from "./RiderManagementConstants";
import Switch from "../../common/Switch/Switch";
export const autoGeneratePass = autoGeneratePassword();

const AddUpdateRiderManagementPage: React.FunctionComponent<
  IAddUpdateRiderManagementPageProps
> = (props: IAddUpdateRiderManagementPageProps) => {
  const [riderManagement, setRiderManagementState] =
    useState<IAddUpdateRiderManagementPageState>({
      id: "",
      userId: props.selectedRiderManagementUser
        ? props.selectedRiderManagementUser.userId || ""
        : "",
      fullName: props.selectedRiderManagementUser
        ? props.selectedRiderManagementUser.fullName || ""
        : "",
      phoneNumber: props.selectedRiderManagementUser
        ? props.selectedRiderManagementUser.phoneNumber || ""
        : "",
      cnic: "",
      email: "",
      title: "",
      warehouseId: props.selectedRiderManagementUser
        ? props.selectedRiderManagementUser.warehouseId || ""
        : "",
      password: autoGeneratePass,
      confirmPassword: autoGeneratePass,
      status: props.selectedRiderManagementUser
        ? props.selectedRiderManagementUser.status === "ACTIVE"
        : true,
      isRiderDetailsFound: props.dummyRiderDetailFound || false,
      resetPasswordModal: props.dummyResetPassword || false,
      resetDeviceModal: props.dummyResetDevice || false,
      jobType:
        props.selectedRiderManagementUser &&
        props.selectedRiderManagementUser.jobType
          ? convertStringArrayToMultiSelectDropdown(
              props.selectedRiderManagementUser.jobType
            ) || []
          : [],
      subType:
        props.selectedRiderManagementUser &&
        props.selectedRiderManagementUser.subType
          ? normalizeSubTypeForDropdown(
              props.selectedRiderManagementUser.subType
            ) || null
          : null,
    });

  const [jobTypesDropdown, setJobTypesDropdown] = useState<
    IMultiSelectOption[]
  >([]);

  const [selectedWarehouse, setSelectedWarehouse] =
    useState<IWarehousePayload>(defaultWarehouse);

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  useEffect(() => {
    const { riderTypes } = props;
    if (
      riderTypes &&
      riderTypes.jobTypes.length > 0 &&
      riderManagement &&
      riderManagement.jobType.length > 0
    ) {
      const { jobTypes } = riderTypes;
      setRiderManagementState({
        ...riderManagement,
        jobType: riderManagement.jobType.filter((item) =>
          jobTypes.includes(item.value)
        ),
      });
    }
    if (
      riderTypes &&
      riderTypes.subTypes.length > 0 &&
      riderManagement &&
      riderManagement.subType
    ) {
      const { subTypes } = riderTypes;
      setRiderManagementState({
        ...riderManagement,
        subType: subTypes.includes(riderManagement.subType.key)
          ? riderManagement.subType
          : null,
      });
    }
    setJobTypesDropdown(
      convertStringArrayToMultiSelectDropdown(props.riderTypes.jobTypes || [])
    );
  }, [props.riderTypes]);

  useEffect(() => {
    const { warehousesList } = props;
    if (
      warehousesList.length > 0 &&
      riderManagement &&
      riderManagement.warehouseId != ""
    ) {
      const selectedWarehouse: IWarehousePayload = getWarehousePayloadById(
        riderManagement.warehouseId,
        normalizeWarehouseResponseForDropdown(props.warehousesList)
      );

      setRiderManagementState({
        ...riderManagement,
        warehouseId: selectedWarehouse.id,
      });
      setSelectedWarehouse(selectedWarehouse);
    }
  }, [props.warehousesList]);

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
      handleToaster(true, (error! as any).errors);
    }
  }, [props.isError]);

  useEffect(() => {
    const { isEdit, searchText } = props;

    if (!isEdit) {
      const getUserDetails = async () => {
        let userDetails = await doUserAPIsearch(searchText);

        if (userDetails) {
          setRiderManagementState({
            ...riderManagement,
            userId: userDetails.id,
            fullName: userDetails.fullName,
            email: userDetails.email,
            cnic: userDetails.nationalId,
            phoneNumber: userDetails.phoneNumber,
            isRiderDetailsFound: true,
          });
        }
      };
      getUserDetails();
    }
  }, []);

  useEffect(() => {
    const {
      getRiderUserDetails,
      selectedRiderManagementUser,
      getRiderJobTypes,
      getWarehouses,
    } = props;

    if (isEdit) {
      getRiderUserDetails(selectedRiderManagementUser.userId);
    }
    getRiderJobTypes();
    getWarehouses();
  }, []);

  useEffect(() => {
    const {
      isRiderManagementUserAdded,
      isRiderUpdated,
      isRiderCreated,
      backButtonHandler,
    } = props;
    if (isRiderManagementUserAdded || isRiderUpdated || isRiderCreated)
      backButtonHandler(true);
  }, [
    props.isRiderManagementUserAdded,
    props.isRiderUpdated,
    props.isRiderCreated,
  ]);

  useEffect(() => {
    const { isRiderUserDetailsFetched, riderUserDetails } = props;

    if (isEdit && isRiderUserDetailsFetched && riderUserDetails != null) {
      setRiderManagementState({
        ...riderManagement,
        email: riderUserDetails.email,
        cnic: riderUserDetails.nationalId ? riderUserDetails.nationalId : "",
      });
    }
  }, [props.isRiderUserDetailsFetched, props.riderUserDetails]);

  const handleSubmit = (e: any) => {
    const { createRiderUser, updateRiderUser, isEdit, createRider } = props;
    if (isEdit) {
      const reqPayload =
        normalizeRiderManagementUserUpdatePayload(riderManagement);
      updateRiderUser(reqPayload);
    } else {
      if (riderManagement.isRiderDetailsFound) {
        const reqPayload = normalizeCreateRiderPayload(riderManagement);
        createRider(reqPayload);
      } else {
        const reqPayload =
          normalizeRiderManagementUserCreatePayload(riderManagement);
        createRiderUser(reqPayload);
      }
    }
  };

  const handleChange = (e: any) => {
    const fieldId: string = e.target.id;
    const fieldValue: string = e.target.value;
    setRiderManagementState({
      ...riderManagement,
      [fieldId]: fieldId === "status" ? !riderManagement[fieldId] : fieldValue,
    });
  };

  const handleGoBackButton = () => {
    const { backButtonHandler } = props;
    backButtonHandler(false);
  };

  const handleCnic = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (numbersOnly(e.target.value)) {
      if (
        e.target.value.length > riderManagement.cnic.length ||
        Math.abs(e.target.value.length - riderManagement.cnic.length) > 1
      ) {
        const formattedCnic = formatnationalId(
          e.target.value.replace(/-/g, "")
        );
        riderManagement.cnic = formattedCnic;
        setRiderManagementState({ ...riderManagement });
      } else {
        riderManagement.cnic = e.target.value;
        setRiderManagementState({ ...riderManagement });
      }
    }
  };

  const handleSearchableSelect = (e: IWarehousePayload, fieldId: string) => {
    setSelectedWarehouse(e);
    setRiderManagementState({
      ...riderManagement,
      [fieldId]: e.id,
    });
  };

  const handleSubTypeSelect = (e: IMultiSelectOption, fieldId: string) => {
    setRiderManagementState({
      ...riderManagement,
      [fieldId]: e,
    });
  };

  const resetPassword = () => {
    const { selectedRiderManagementUser, isEdit, backButtonHandler } = props;
    const userId: string =
      selectedRiderManagementUser && selectedRiderManagementUser.userId;
    const passwordPayload = {
      password: autoGeneratePass,
      passwordConfirmation: autoGeneratePass,
    };
    if (isEdit && (updateUserPasswordApiCall(userId, passwordPayload) as any)) {
      resetPasswordConfirmationModal();
      backButtonHandler(true);
    } else {
      backButtonHandler(false);
    }
  };

  const resetDevice = () => {
    const { selectedRiderManagementUser, isEdit, backButtonHandler } = props;
    const userId: string =
      selectedRiderManagementUser && selectedRiderManagementUser.userId;
    const resetDevicePayload = {
      userId,
    };
    if (isEdit) {
      updateRiderDeviceApiCall(resetDevicePayload);
      resetDeviceConfirmationModal();
      backButtonHandler(true);
    } else {
      backButtonHandler(false);
    }
  };

  const resetPasswordConfirmationModal = () => {
    setRiderManagementState({
      ...riderManagement,
      resetPasswordModal: !riderManagement.resetPasswordModal,
    });
  };
  const resetDeviceConfirmationModal = () => {
    setRiderManagementState({
      ...riderManagement,
      resetDeviceModal: !riderManagement.resetDeviceModal,
    });
  };

  const formatnationalId = (str: string) => {
    if (str.length >= 5) {
      if (str.length >= 12) {
        let firstPart = str.substring(0, 5);
        let secondPart = str.substring(5, str.length);
        firstPart += "-";
        let newFinal = firstPart + secondPart;
        firstPart = newFinal.substring(0, 13);
        firstPart += "-";
        secondPart = newFinal.substring(13, newFinal.length);
        return firstPart + secondPart;
      } else {
        let firstPart = str.substring(0, 5);
        let secondPart = str.substring(5, str.length);
        firstPart += "-";
        return firstPart + secondPart;
      }
    }
    return str;
  };

  const {
    fullName,
    phoneNumber,
    password,
    confirmPassword,
    cnic,
    email,
    jobType,
    warehouseId,
    subType,
  } = riderManagement;

  const handleTaskTypeChange = (values: IMultiSelectOption[]) => {
    setRiderManagementState({
      ...riderManagement,
      jobType: [...values],
    });
  };
  const validateForm = riderManagement.isRiderDetailsFound
    ? props.dummyValidation ||
      (fullName.length > 0 &&
        phoneNumber.length > 0 &&
        jobType.length > 0 &&
        cnic.length > 0 &&
        new RegExp(cnicNumberValidate).test(cnic) &&
        warehouseId.length > 0 &&
        password === confirmPassword &&
        subType !== null)
    : props.dummyValidation ||
      (fullName.length > 0 &&
        phoneNumber.length > 0 &&
        jobType.length > 0 &&
        email.length > 0 &&
        cnic.length > 0 &&
        new RegExp(cnicNumberValidate).test(cnic) &&
        warehouseId.length > 0 &&
        password === confirmPassword &&
        subType !== null);

  const { resetPasswordModal, resetDeviceModal } = riderManagement;

  const { isEdit } = props;

  const buttonText = isEdit ? RIDER.UPDATE_RIDER : RIDER.CREATE_ACCOUNT;

  const headingText = isEdit ? RIDER.UPDATE_RIDER : RIDER.ADD_RIDER;

  const renderFormButton = () => {
    return (
      <div className="form-row-separator">
        <Row id="addEditButtonRow" className="add-update-button-container">
          <Can I="create" a="rider">
            <Col lg="6">
              <ButtonComponent
                buttonClass="large-button btn-primary"
                buttonText={buttonText}
                onClickHandler={handleSubmit}
                isDisable={props.isLoading || !validateForm}
              />
            </Col>
          </Can>
        </Row>
      </div>
    );
  };

  const renderRiderCreation = () => {
    return (
      <div>
        <Modal
          showModal={resetPasswordModal || resetDeviceModal}
          closeModalHandler={
            resetPasswordModal
              ? resetPasswordConfirmationModal
              : resetDeviceConfirmationModal
          }
          modalHeading={resetPasswordModal ? "Change password" : "Reset Device"}
          showProgressString={false}
          failedRecords=""
          modalBodyClass="verify-account"
        >
          {
            <>
              <p>
                {resetPasswordModal
                  ? "Are you sure you want to change the password?"
                  : "Are you sure you want to Reset Device?"}
              </p>
              <Row>
                <Col className="col-lg-5">
                  <ButtonComponent
                    buttonClass="button-full btn btn-primary-outline"
                    buttonText="Go back"
                    onClickHandler={
                      resetPasswordModal
                        ? resetPasswordConfirmationModal
                        : resetDeviceConfirmationModal
                    }
                  />
                </Col>
                <Col className="col-lg-7 no-padding-left">
                  <ButtonComponent
                    buttonClass="button-full btn btn-primary"
                    buttonText={
                      resetPasswordModal ? "Change Password" : "Reset Device"
                    }
                    onClickHandler={
                      resetPasswordModal ? resetPassword : resetDevice
                    }
                  />
                </Col>
              </Row>
            </>
          }
        </Modal>
        <FormSectionLayout subTitleText="Account Details">
          <TextField
            id="fullName"
            label="Full Name"
            placeholder="e.g. Bill Gates"
            value={fullName}
            handleChange={handleChange}
            error={alphaNumericValidator(fullName)}
          />
          <TextField
            id="phoneNumber"
            label="Phone Number"
            placeholder="e.g. 03421231231"
            value={phoneNumber}
            handleChange={handleChange}
            validator={phoneNumberValidate}
            error={phoneNumberOnlyValidator(phoneNumber)}
            disabled={isEdit || riderManagement.isRiderDetailsFound}
          />
          <TextField
            id="email"
            label="Email"
            placeholder="bill.gates@live.com"
            value={email}
            handleChange={handleChange}
            disabled={riderManagement.isRiderDetailsFound}
          />
          <TextField
            id="nationalId"
            label="CNIC Number"
            placeholder="e.g. 11111-1111111-1"
            value={cnic}
            handleChange={handleCnic}
            validator={cnicNumberValidate}
            maxLength={15}
            error={cnicNumberOnlyValidator(cnic)}
            isOptional={false}
            // disabled={riderManagement.isRiderDetailsFound}
          />
          <MultiSelectDropDown
            options={jobTypesDropdown}
            label="Select rider job type"
            selectedValues={riderManagement.jobType}
            placeholder={"Please select job type"}
            displayValue="label"
            onChange={handleTaskTypeChange}
            onRemove={handleTaskTypeChange}
          />
          <SearchableSelect
            id="selectedSubType"
            isSearchable={true}
            options={normalizeSubTypeResponseForDropdown(
              props.riderTypes.subTypes || []
            )}
            onChange={(e: any) => {
              handleSubTypeSelect(e, "subType");
            }}
            label="Select sub-type"
            placeholder="Select sub-type"
            selectedValue={riderManagement.subType}
          />
          <SearchableSelect
            id="selectedWarehouse"
            isSearchable={true}
            options={normalizeWarehouseResponseForDropdown(
              props.warehousesList
            )}
            onChange={(e: any) => {
              handleSearchableSelect(e, "warehouseId");
            }}
            label="Select warehouse"
            placeholder="Select warehouse"
            selectedValue={selectedWarehouse}
          />
          <Switch
            id="status"
            label="Status"
            checked={riderManagement.status as boolean}
            handleSwitch={handleChange}
            statusVal1={"ACTIVE"}
            statusVal2={"INACTIVE"}
          />
          {isEdit ? (
            <div className={isEdit ? "form-row" : ""}>
              <Row className="add-update-button-container">
                <Col>
                  <Can I="update" a="password">
                    <ButtonComponent
                      buttonClass="btn btn-primary-outline button-large reset-button"
                      buttonText="Reset password"
                      onClickHandler={resetPasswordConfirmationModal}
                    />
                  </Can>
                </Col>
                <Col>
                  <Can I="update" a="device">
                    <ButtonComponent
                      buttonClass="btn btn-primary-outline button-large reset-button"
                      buttonText="Reset Device"
                      onClickHandler={resetDeviceConfirmationModal}
                    />
                  </Can>
                </Col>
              </Row>
            </div>
          ) : (
            <TextField
              id="password"
              label="Password"
              placeholder="Please enter a secure password"
              type="password"
              value={password}
              handleChange={handleChange}
              disabled={true}
            />
          )}

          {renderFormButton()}
        </FormSectionLayout>
      </div>
    );
  };

  return (
    <Container fluid className="rider-creation-container">
      <Row>
        <Col>
          <div className="back-button">
            <a href="javascript:void(0)" onClick={handleGoBackButton}>
              <span>
                <img src={backarrow} alt="close" />
              </span>{" "}
              Back to Riders
            </a>
          </div>
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      {props.isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="">{renderRiderCreation()}</div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

AddUpdateRiderManagementPage.defaultProps = {
  dummyValidation: false,
  dummyResetPassword: false,
  dummyResetDevice: false,
  dummyRiderDetailFound: false,
};

export default AddUpdateRiderManagementPage;
